import SideMenuStore from '../components/SideMenu/SideMenuStore';
import ConnectPracticeStore from '../pages/ConnectPractice/ConnectPracticeStore';
import DashboardStubStore from '../pages/DashboardStub/DashboardStubStore';
import ManageBreedsStore from '../pages/ManageBreeds/ManageBreedsStore';
import ManageSpeciesStore from '../pages/ManageSpecies/ManageSpeciesStore';
import OfferSetupStore from '../pages/OfferSetup/OfferSetupStore';
import ApiStore from './ApiStore';
import GlobalModalStore from './GlobalModalStore';
import GlobalStore from './GlobalStore';

export default class RootStore {
  public readonly globalStore = new GlobalStore(this);
  public readonly globalModalStore = new GlobalModalStore(this);
  public readonly apiStore = new ApiStore(this);
  public readonly sideMenuStore = new SideMenuStore(this);
  public readonly dashboardStubStore = new DashboardStubStore(this);
  public readonly connectPracticeStore = new ConnectPracticeStore(this);
  public readonly offerSetupStore = new OfferSetupStore(this);
  public readonly manageSpeciesStore = new ManageSpeciesStore(this);
  public readonly manageBreedsStore = new ManageBreedsStore(this);

  // no methods allowed in this class because they will be anyway unavailable in useStore() hook result
}
